import fp from 'lodash/fp';
import { all, takeEvery } from 'redux-saga/effects';
import * as sagas from './redux/sagas';
import * as routines from './redux/sagas/routines';

const reduce = fp.reduce.convert({ cap: false });

export function* rootSagas() {
  yield all(
    reduce(
      (allSaga, saga, type) => [
        ...allSaga,
        takeEvery(fp.getOr(type, `${type}.TRIGGER`, routines), saga)
      ],
      [],
      sagas
    )
  );
}
/* eslint-enable */
